












import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Store types
import { ToolSystem, ToolUnit } from '@/store/store.types';

// Internal components
import OverviewSystemUnit from './OverviewSystemUnit.vue';

/**
 *  Component that renders every unit that is included
 *  in the system for which it is rendered.
 */
@Component({
    components: {
        OverviewSystemUnit,
    },
})
export default class OverviewSystemUnits extends Vue {

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

    /**
     *  Used to return all the (tool) units of the system.
     */
    private get toolUnits(): Array<ToolUnit> {

        return [
            ...this.toolSystem.indoorUnits,
            ...this.toolSystem.outdoorUnits,
        ];

    }

}
